import { StyledText } from './styles';
import { usePreReleaseFeatures } from 'hooks/usePreReleaseFeatures';
import { emptyLongDash } from 'components/Inputs/DateTimeInput/helpers';

const SingleValue = ({ getValue }) => {
  const val = getValue()?.[0];
  const preReleaseFeatures = usePreReleaseFeatures();

  return (
    <StyledText
      {...(val?.label &&
        preReleaseFeatures && {
          type: 'link',
          to: `/team-member/${val.id || val.value}/timeline`,
        })}
    >
      {val?.label || emptyLongDash}
    </StyledText>
  );
};

export default SingleValue;
